import * as React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { Row, Col, Label, Card, Button } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import classNames from 'classnames';
import { renderHeader } from "./TableUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function OrderSummary({
    tenant,
    order,
    isBackOffice,
    delivery
}) {
    const { domains, geo } = useAuth0();


    return (
        <Card body color="default">
            <Row>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Numero ordine</strong>
                    <Label className="mt-1 d-block h5">{order._id}</Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Stato ordine</strong>
                    <Label className="mt-1 d-block h5"><span className={classNames('customer-badge', 'status-' + order.status)}>{order.status}</span></Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Rif. ordine</strong>
                    <Label className="mt-1 d-block h5">{order.order_ref}</Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Ultimo aggiornamento</strong>
                    <Label className="mt-1 d-block h5">
                        {moment(delivery.updatedat).format("DD/MM/YYYY")}
                    </Label>
                </Col>
            </Row>

            <Row>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Creato da</strong>
                    <Label className="mt-1 d-block h5">{order.creator_email}</Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Data ordine</strong>
                    <Label className="mt-1 d-block h5">
                        {order.createdat ? moment(order.createdat).format("DD/MM/YYYY") : "N.D."}
                    </Label>
                </Col>
            </Row>

            <Row>
                <Col sm="3" xs="6">
                    <strong className="mt-1 d-block">Modello</strong>
                    <Label className="mt-1 d-block h5">
                        {domains.devicesType.find(item => item.value === order.model).label}
                    </Label>
                </Col>
                <Col sm="3" xs="6">
                    <strong className="mt-1 d-block">Quantitá</strong>
                    <Label className="mt-1 d-block h5">{order.quantity}</Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Data consegna richiesta</strong>
                    <Label className="mt-1 d-block h5">
                        {order.delivery_date ? moment(order.delivery_date).format("DD/MM/YYYY") : "N.D."}
                    </Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Data spedizione</strong>
                    <Label className="mt-1 d-block h5">
                        {order.shipment_date ? order.shipment_date : null}
                    </Label>
                </Col>
            </Row>

            <Row>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Cliente</strong>
                    <Label className="mt-1 d-block h5">{order.created_for}</Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Indirizzo di spedizione</strong>
                    <Label className="mt-1 d-block h5">
                        {`${tenant.address.street} - ${
                            tenant.address.cap
                            } ${geo.getComuneLabel(tenant.address.city)} (${tenant.address.province.toUpperCase()})`}
                    </Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Num. spedizione (DHL waybill)</strong>
                    <Label className="mt-1 d-block h5">
                        {order.waybill ?
                            <a href={`https://www.dhl.com/it-it/home/tracciabilita.html?tracking-id=${order.waybill}&submit=1`} className="btn btn-success" target="_blank">{order.waybill}</a>
                            : null}
                    </Label>
                </Col>
                <Col sm="6" xs="12" md="3">
                    <strong className="mt-1 d-block">Data consegnato</strong>
                    <Label className="mt-1 d-block h5">
                        {order.delivered_date ? order.delivered_date : null}
                    </Label>
                </Col>
            </Row>

            <Row>
                <Col xs="12">
                    <strong className="mt-1 d-block">Note ordine</strong>
                    <Label className="mt-1 d-block h5">{order.notes}</Label>
                </Col>
            </Row>

            {delivery && (
                <div xs="12">
                    <div className="divider my-3" />
                    <strong className="my-1 d-block">Dispositivi associati:</strong>
                    <DataTable
                        value={delivery.meta.devices}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        emptyMessage={() => (<div className="text-center">Nessun Dispositivo in tabella</div>)}
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={10}
                        totalRecords={delivery.meta.devices.length}
                        paginatorPosition="both"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Visualizzati {first} di {last} Dispositivi su un totale di {totalRecords}"
                    >
                        <Column
                            field="imei"
                            style={{ wordWrap: "break-word" }}
                            header="IMEI"
                            sortable
                            filter
                            filterMatchMode="contains"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/backoffice/devices/${rowData._id}`}
                                    >
                                        {rowData.imei}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="serial"
                            header="Seriale"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="number"
                            header="Telefono"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="iccid"
                            header="ICCID"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="model"
                            header="Modello"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </div>
            )}
        </Card>
    );
}
